/* Webstra 10/2026: Ergaenzungen Produktseite. Laedt nach gm-pdp.js / gm-extras.js.
   1. Preisformat im Warenkorb-Button (19,90 €)  2. Shopbewertung  3. "Farbe wählen" aus Metafeld
   4. Schritt "Stadt wählen" fuer Skyline-Produkte ohne Wunschtext  5. Galerie-Vorschaubilder nach Groessenwechsel */
(function(){
if(window.__gmWebstra)return;
window.__gmWebstra=true;

/* 1. dynamic.js nutzt theme.formatMoney, sonst faellt es auf "19.90" zurueck */
window.theme=window.theme||{};
if(!window.theme.formatMoney){
  window.theme.formatMoney=function(c){
    c=Number(c)||0;
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
    try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:cur}).format(c/100);}
    catch(e){return (c/100).toFixed(2).replace('.',',')+' €';}
  };
}

function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
function $(s,r){return (r||document).querySelector(s);}
function renumber(info){var i=0;info.querySelectorAll('.gm-step__n').forEach(function(n){n.textContent=++i;});}
function step(title,value){
  var d=document.createElement('div');
  d.className='gm-step';
  d.innerHTML='<span class="gm-step__n" aria-hidden="true"></span><span class="gm-step__t"></span>'+(value?'<span class="gm-step__v"></span>':'');
  d.querySelector('.gm-step__t').textContent=title;
  if(value)d.querySelector('.gm-step__v').textContent=value;
  return d;
}

/* 2. Shopbewertung: die Sterne ueber dem Titel stammen aus allen Shop-Bewertungen, nicht vom Produkt */
function shopRating(){
  var tries=0;
  (function poll(){
    var t=$('.gm-rating .gm-rating__t');
    if(!t){if(tries++<50)setTimeout(poll,400);return;}
    if(t.getAttribute('data-gm-shop'))return;
    t.setAttribute('data-gm-shop','1');
    t.innerHTML=t.innerHTML.replace(/ Bewertungen/,' Shopbewertungen');
    var a=t.closest('.gm-rating');
    if(a){var l=a.getAttribute('aria-label')||'';a.setAttribute('aria-label',l.replace('Shop-Bewertung','Shopbewertung').replace(/aus (\d+) Bewertungen/,'aus $1 Shopbewertungen'));}
  })();
}

function run(){
  var info=$('.product__info-container');
  if(!info)return;

  /* 3. Set-Schritt: Beschriftung aus dem Metafeld connect_variant_title ("Wähle deine Farbe:" -> "Farbe wählen") */
  var set=$('.variant-option-v3',info);
  if(set){
    var vt=$('.variant-title-con',set);
    if(vt&&/farbe/i.test(vt.textContent)){
      var st=set.previousElementSibling;
      var tt=st&&st.classList.contains('gm-step')?st.querySelector('.gm-step__t'):null;
      if(tt)tt.textContent='Farbe wählen';
      set.classList.add('gm-set--color');
      var pr=[].map.call(set.querySelectorAll('.product-price'),function(e){return e.textContent.replace(/\s+/g,'');}).filter(Boolean);
      if(pr.length>1&&pr.every(function(x){return x===pr[0];}))set.classList.add('gm-set--sameprice');
    }
  }

  /* 4. Stadt-Schritt fuer Skyline-Produkte ohne Wunschtext (z. B. Windlichter). Mit Wunschtext macht das gm-skyline.js. */
  var city=$('variant-selects-cust.two-grid-option',info);
  var hasCity=[].some.call(info.querySelectorAll('.gm-step__t'),function(t){return /Stadt/i.test(t.textContent);});
  if(city&&!hasCity&&!$('.gm-sky-city,.gm-tf-city',info)&&!$('[input-main-wapper]',info)&&!$('input[name^="properties[addon Dein Wunschtext"]',info)){
    var cl=city.querySelector('.form__label'),cs=city.querySelector('.select__select');
    if(cl&&cs&&/Stadt/i.test(cl.textContent)){
      var co=cs.options[cs.selectedIndex];
      var cv=co?co.textContent.trim().toLowerCase().replace(/(^|[\s-])\S/g,function(c){return c.toUpperCase();}):'';
      var cst=step('Stadt wählen',cv);
      cst.classList.add('gm-sky-city','gm-wb');
      city.parentNode.insertBefore(cst,city);
      cl.classList.add('gm-sr');
      if(!cs.getAttribute('aria-label'))cs.setAttribute('aria-label','Stadt wählen');
    }
  }
  renumber(info);
  document.addEventListener('gm:cfg-ready',function(){setTimeout(function(){renumber(info);},0);});
  /* Sicherheitsnetz: falls ein anderes Skript spaeter ebenfalls "Stadt wählen" einfuegt, unseren Schritt wieder entfernen */
  setTimeout(function(){
    var mine=$('.gm-sky-city.gm-wb',info);
    if(!mine)return;
    var n=[].filter.call(info.querySelectorAll('.gm-step__t'),function(t){return /Stadt/i.test(t.textContent);}).length;
    if(n>1){mine.remove();var l=$('variant-selects-cust.two-grid-option .form__label',info);if(l)l.classList.remove('gm-sr');renumber(info);}
  },2500);
}

/* 6. Aperol/Lillet: Motive gibt es teils doppelt (mit und ohne Wunschname, z. B. "Queen" und "Aperol Queen").
   Jedes Motiv nur einmal zeigen und darunter einen Umschalter "Ohne / Mit Wunschname" anbieten. */
function wunschname(info){
  if(!/template-wein_puccini_(aperol|lillet)/.test(document.body.className))return;
  var box=$('variant-selects-cust.two-grid-option-swatch',info);
  if(!box||$('.gm-wn',info))return;
  var SUF=/-mit-wunschname$/;
  var path=location.pathname.split('?')[0].replace(/\/$/,'');
  var curMit=SUF.test(path);
  var groups={};
  [].forEach.call(box.querySelectorAll('.swiper-slide'),function(sl){
    var a=sl.querySelector('a.mo-item');if(!a)return;
    var h=(a.getAttribute('href')||'').split('?')[0].replace(/\/$/,'');
    var k=h.replace(SUF,'');
    (groups[k]=groups[k]||[]).push({sl:sl,a:a,h:h,mit:SUF.test(h)});
  });
  var other=null;
  Object.keys(groups).forEach(function(k){
    var g=groups[k];
    if(g.length<2)return;
    var keep=g.filter(function(x){return x.mit===curMit;})[0]||g[0];
    var long='';
    g.forEach(function(x){var t=x.a.querySelector('.item-title');var v=t?t.textContent.trim():'';if(v.length>long.length)long=v;});
    g.forEach(function(x){
      if(x!==keep)x.sl.classList.add('gm-dup');
      if(path===x.h||path===keep.h){g.forEach(function(y){if(y.h!==path)other=y.h;});}
    });
    var kt=keep.a.querySelector('.item-title');if(kt&&long)kt.textContent=long;
  });
  /* Wert im Schritt "Motiv wählen" an den laengeren Namen anpassen */
  var mv=box.previousElementSibling&&box.previousElementSibling.querySelector('.gm-step__v');
  var curT=box.querySelector('a.mo-item.is-current .item-title');
  if(mv&&curT)mv.textContent=curT.textContent.trim();
  if(!other)return;
  var ohne=curMit?other:path, mit=curMit?path:other;
  var wrap=document.createElement('div');
  var st=step('Wunschname',curMit?'mit Wunschname':'ohne Wunschname');
  var nav=document.createElement('div');
  nav.className='gm-wn';
  nav.setAttribute('role','group');
  nav.setAttribute('aria-label','Wunschname');
  nav.innerHTML='<a href="'+ohne+'"'+(curMit?'':' aria-current="true"')+'>Ohne Wunschname</a><a href="'+mit+'"'+(curMit?' aria-current="true"':'')+'>Mit Wunschname</a>';
  wrap.appendChild(st);wrap.appendChild(nav);
  var set=$('.variant-option-v3',info);
  var after=set||box;
  after.parentNode.insertBefore(wrap,after.nextSibling);
}

/* 5. Vorschaubilder links: Swiper behielt nach einem Wechsel von Mobil- auf Desktopbreite die horizontale Richtung -> duenne Streifen */
function thumbs(){
  var t=$('.thumb_slider__left .swiprt_thumbnail_slider')||$('.thumb_slider__right .swiprt_thumbnail_slider');
  if(!t||!t.swiper||!t.swiper.changeDirection)return;
  var want=window.innerWidth>=750?'vertical':'horizontal';
  if(t.swiper.params.direction!==want){t.swiper.changeDirection(want,false);t.swiper.update();}
}

ready(function(){
  try{run();}catch(e){if(window.console)console.warn('gm-webstra',e);}
  try{var inf=$('.product__info-container');if(inf){wunschname(inf);renumber(inf);}}catch(e){if(window.console)console.warn('gm-webstra wn',e);}
  shopRating();
  thumbs();
  var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(thumbs,150);});
  window.addEventListener('load',thumbs);
});
})();
